import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { documentTitle, resolvePageMeta } from "./pageMeta";

const DocumentMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = resolvePageMeta(pathname);
    document.title = documentTitle(meta);

    let tag = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    if (!tag) {
      tag = document.createElement("meta");
      tag.name = "description";
      document.head.appendChild(tag);
    }
    tag.content = meta.description;
  }, [pathname]);

  return null;
};

export default DocumentMeta;

